import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from '../../redux/Slices/modalSlice';
import { Close } from '../icons';
import './scss/StartTrialModal.scss'; // Reuse existing modal styles for consistency

const WarningModal = () => {
    const dispatch = useDispatch();
    const { modalData } = useSelector(state => state.modal);
    
    const handleClose = () => {
        dispatch(closeModal());
    };

    if (!modalData) return null;

    const { message, title = 'Warning' } = modalData;

    return (
        <div className="start-trial-modal" style={{ maxWidth: '400px' }}>
            <div className="trial-modal-header" style={{ padding: '20px', borderBottom: '1px solid var(--border-color)' }}>
                <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text-color)' }}>
                    {title}
                </h2>
                <button className="close-button" onClick={handleClose}>
                    <Close size={20} />
                </button>
            </div>

            <div className="trial-modal-body" style={{ padding: '20px' }}>
                <div style={{ marginBottom: '24px', color: 'var(--text-color-secondary)', lineHeight: '1.5' }}>
                    {message}
                </div>

                <div className="trial-modal-actions" style={{ marginTop: '0' }}>
                    <button 
                        className="start-trial-button" 
                        onClick={handleClose}
                        style={{ width: '100%', padding: '10px' }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WarningModal;
